const CategoryShow = () => import('@/modules/categories/views/CategoryShow.vue')
const CategoryEdit = () => import('@/modules/categories/views/CategoryEdit.vue')
const CategoryCreate = () => import('@/modules/categories/views/CategoryCreate.vue')
const CategoryIndex = () => import('@/modules/categories/views/CategoryIndex.vue')

export default [
  {
    path: '/categories',
    name: 'categories.index',
    component: CategoryIndex,
    meta: { requiresAuthentication: true }
  },
  {
    path: '/categories/create',
    name: 'categories.create',
    component: CategoryCreate,
    meta: { requiresAuthentication: true }
  },
  {
    path: '/:username/c/:slug/edit',
    name: 'categories.edit',
    component: CategoryEdit,
    meta: { requiresAuthentication: true }
  },
  {
    path: '/:username/c/:slug',
    name: 'categories.show',
    component: CategoryShow
  }
]
